import Vue from 'vue'
import Vuex from 'vuex'
import ui, {UI} from '@/store/modules/ui';
import user, {UserState} from "@/store/modules/user";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export interface State {
	ui: UI;
	user: UserState;
}

export default new Vuex.Store<State>({
	mutations: {},
	actions: {},
	modules: {
		ui: ui,
		user: user,
	},
	plugins: [
		createPersistedState({
			storage: window.localStorage,
			key: 'top-drivers-user-store',
			reducer: (persistedState: State) => {
				const stateFilter = JSON.parse(JSON.stringify(persistedState)) as State;

				delete stateFilter.ui;
				delete stateFilter.user.isRefreshingToken;

				return stateFilter
			}
		}),
	]
});
